























































































































import Vue from 'vue';
import CampaignMappingFieldResourceViewModel from '../../../../services/v1/viewModel/resource/CampaignMappingFieldResourceViewModel';
import GetCampaignFieldMappingsRequestViewModel from '../../../../services/v1/viewModel/request/FieldMapping/GetCampaignFieldMappingsRequestViewModel';
import AppSystemResourceViewModel from '../../../../services/v1/viewModel/resource/AppSystemResourceViewModel';
import CampaignCustomFieldResourceListResultViewModel from '../../../../services/v1/viewModel/resource/CampaignCustomFieldResourceListResultViewModel';
import CampaignCustomFieldResourceViewModel from '../../../../services/v1/viewModel/resource/CampaignCustomFieldResourceViewModel';
import ResponsePagingInfo from '../../../../plugins/servicelayer/responseTypes/responsePagingInfo';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    /** Lookup appSystemId -> custom fields */
    customFieldsLookup: {} as Record<number, CampaignCustomFieldResourceViewModel[]>,
    isLoadingEntry: false,
    isLoadingFields: false,
    responseError: undefined as any,
    isAppSystemsLoading: false,
    getAppSystemsError: undefined as any,
    pagination: {} as ResponsePagingInfo,
    filter: {
      appSystemId: undefined as number | undefined,
      otherAppSystemId: undefined as number | undefined,
    },
    innerPagination: {
      'paging.CurrentPage': undefined as number | undefined,
      'paging.PageSize': undefined as number | undefined,
      'paging.IncludeCount': undefined as boolean | undefined,
      'paging.NoPaging': undefined as boolean | undefined,
    },
    list: [] as CampaignMappingFieldResourceViewModel[],
    columns: [] as {}[],
    appSystems: [] as AppSystemResourceViewModel[],
  }),
  computed: {
    request() {
      return new GetCampaignFieldMappingsRequestViewModel().fromModel({ ...this.filter, ...this.innerPagination });
    },
    appSystemsWithFields() {
      return this.appSystems.filter((appSystem) => this.customFieldsLookup[appSystem.id!]?.length > 0);
    },
    queryAppSystemId() {
      return Vue.$router.currentRoute.query.appSystemId;
    },
    queryOtherAppSystemId() {
      return Vue.$router.currentRoute.query.otherAppSystemId;
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.$debounce(() => {
          this.pagination.currentPage = 1;
          this.innerPagination['paging.CurrentPage'] = 1;
          this.refresh();
        }, 300, this)();
      },
    },
    request() {
      this.writeRequestToQuery();
    },
  },
  beforeMount() {
    this.getQueryFromRequest();
    this.pagination.currentPage = this.innerPagination['paging.CurrentPage'] !;
    this.pagination.pageSize = this.innerPagination['paging.PageSize'] !;
  },
  async mounted() {
    this.columns = [
      {
        value: '', textAlign: 'left', field: 'icon',
      },
      {
        value: this.$t('core.page.fieldmapping.properties.id'), textAlign: 'left', field: 'id',
      },
      {
        value: this.$t('core.page.fieldmapping.properties.appSystem1Id'), textAlign: 'left', field: 'appSystem1Id', format: this.getAppSystemCaption,
      },
      {
        value: this.$t('core.page.fieldmapping.properties.field1Id'), textAlign: 'left', field: 'field1Id',
      },
      { value: this.$t('core.page.fieldmapping.properties.field1Value'), textAlign: 'left', field: 'field1Value' },
      {
        value: this.$t('core.page.fieldmapping.properties.appSystem2Id'), textAlign: 'left', field: 'appSystem2Id', format: this.getAppSystemCaption,
      },
      {
        value: this.$t('core.page.fieldmapping.properties.field2Id'), textAlign: 'left', field: 'field2Id',
      },
      { value: this.$t('core.page.fieldmapping.properties.field2Value'), textAlign: 'left', field: 'field2Value' },
    ];
    await this.getAppSystems();
    await this.getCustomFields();
  },
  methods: {
    getQueryFromRequest() {
      const queryParams = new GetCampaignFieldMappingsRequestViewModel();
      queryParams.fromQuery(this.$routerUtils.getQueryParams());
      this.filter.appSystemId = queryParams.appSystemId;
      this.filter.otherAppSystemId = queryParams.otherAppSystemId;

      this.innerPagination['paging.CurrentPage'] = queryParams['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = queryParams['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = queryParams['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = queryParams['paging.NoPaging'];
    },
    async writeRequestToQuery() {
      this.$debounce(() => {
        this.$routerUtils.updateQueryParams(this.request.toQuery(), { preserve: false });
      }, 200, this.writeRequestToQuery)();
    },
    getCanSave(row: any) {
      return row.appSystem1Id?.value
        && row.field1Id?.value
        && row.appSystem2Id?.value
        && row.field2Id?.value;
    },
    getCustomFieldCaption(id: string, appSystemId: number) {
      let customFields = [] as CampaignCustomFieldResourceViewModel[];
      Object.keys(this.customFieldsLookup).forEach((key: any) => {
        customFields = customFields.concat(this.customFieldsLookup[key]);
      });
      return customFields.find((cf) => cf.id === id && cf.appSystemId === appSystemId)?.caption;
    },
    async getCustomFields() {
      this.isLoadingFields = true;
      const allPromises = [] as Promise<CampaignCustomFieldResourceListResultViewModel>[];
      this.appSystems.forEach((system) => {
        if (system.id) {
          const promise = this.$service.api.core.appSystem.getCustomFields(system.id);
          allPromises.push(promise);
        }
      });
      const responses = await Promise.allSettled(allPromises);
      responses.forEach((response, i) => {
        if (response.status === 'fulfilled') {
          const { value } = response;
          this.$set(this.customFieldsLookup, this.appSystems[i].id!, value.items);
        } else if (response.reason?.status !== 404) {
          this.responseError = response.reason;
          this.$log.error(response.reason);
        }
      });
      this.isLoadingFields = false;
    },
    onRowDoubleClick(row: any) {
      row.editMode = true;
    },
    addNewEntry() {
      this.list.unshift(new CampaignMappingFieldResourceViewModel());
      this.$nextTick(() => {
        (this.list[0] as any).editMode = true;
      });
    },
    async deleteEntry(row: any, index: number) {
      const id = row.id?.value;
      const confirmed = await this.$dialog.confirm(this.$t('core.page.fieldmapping.deleteMappingConfirmation.title'), this.$t('core.page.fieldmapping.deleteMappingConfirmation.message'));
      if (confirmed) {
        try {
          await this.$service.api.core.fieldMapping.deleteCampaignFieldMapping(id);
          this.list.splice(index, 1);
        } catch (error: any) {
          this.responseError = error;
        }
      }
    },
    async saveEdit(row: any) {
      this.isLoadingEntry = true;
      const model = new CampaignMappingFieldResourceViewModel().fromDTO(row.values);
      const id = row.id?.value;
      try {
        if (id === undefined) {
          const newId = await this.$service.api.core.fieldMapping.createCampaignFieldMapping(model);
          row.id = {};
          row.id.value = newId;
        } else {
          await this.$service.api.core.fieldMapping.updateCampaignFieldMapping(id, model);
        }
        row.editMode = false;
      } catch (error: any) {
        this.responseError = error;
      }
      this.isLoadingEntry = false;
    },
    cancelEdit(row: any, index: number) {
      const isNew = row.id?.value === undefined;
      if (isNew) {
        this.list.splice(index, 1);
      } else {
        row.editMode = false;
      }
    },
    refresh() {
      const mappingList = this.$refs.mappingList as any;
      mappingList?.populateList();
    },
    populateData(params: any) {
      this.innerPagination['paging.CurrentPage'] = params.query['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = params.query['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = params.query['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = params.query['paging.NoPaging'];
      return this.$service.api.core.fieldMapping.getCampaignFieldMappings(this.request);
    },
    async getAppSystems() {
      this.isAppSystemsLoading = true;
      try {
        const response = await this.$service.api.core.appSystem.getAppSystems();
        this.appSystems = response.items;
      } catch (error: any) {
        this.getAppSystemsError = error?.message ?? error;
      }
      this.isAppSystemsLoading = false;
    },
    getAppSystemCaption(id: number) {
      return this.appSystems.find((k) => k.id === id)?.caption;
    },
  },
});
